import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import { createHead } from '@vueuse/head'
import { createPinia } from 'pinia'

// Import all of your layout components
import HeaderLayout from './components/layouts/HeaderLayout.vue'
import NoHeaderLayout from './components/layouts/NoHeaderLayout.vue'
import TestCreationLayout from './components/layouts/TestCreationLayout.vue'
// Add any other layouts you have, e.g., HandwritingToTextLayout
// import HandwritingToTextLayout from './components/layouts/HandwritingToTextLayout.vue'
import PrimeVue from 'primevue/config'

// Vuetify imports
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({ components, directives })
const app = createApp(App)
app.use(createPinia())
const head = createHead()

// Register all layout components globally so App.vue can find them by string name
app.component('HeaderLayout', HeaderLayout)
app.component('NoHeaderLayout', NoHeaderLayout)
app.component('TestCreationLayout', TestCreationLayout)
// app.component('HandwritingToTextLayout', HandwritingToTextLayout)

// Use plugins
app.use(router)
app.use(vuetify)
app.use(head)
app.use(PrimeVue)

// Mount the app
app.mount('#app')
